export default {
    title: 'CREATE COMPANY-MEGA-TREND',
    pageTitle: 'Create company-mega-trend'
}
